import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Title } from 'components/misc'
import { Input, Select } from 'components/fields'
import assessorsDropdownSelector from '../../../redux/selectors/assessors/assessorsDropdownSelector'
import { apiConfiguration, apiAssessors } from 'helpers/decorators/api'
import { connect } from 'react-redux'
import styles from './assessor.styl'

@injectIntl
@apiConfiguration()
@apiAssessors()
@connect(({ api }) => ({
  assessor: api.assessor
}))
class Assessor extends Component {
  static propTypes = {
    titles: PropTypes.array,
    colorClass: PropTypes.string,
    formPrefix: PropTypes.string,
    sectionIntlKey: PropTypes.string,
    sectionTitle: PropTypes.string,
    promptIntlKey: PropTypes.string,
    promptDefault: PropTypes.string,
    disabledIntlKey: PropTypes.string,
    disabledDefault: PropTypes.string,
    subcategoryValue: PropTypes.oneOf(PropTypes.number, PropTypes.string),
    setupAssessorId: PropTypes.number,
    assessor: PropTypes.object,
    disabled: PropTypes.bool,
    intl: PropTypes.object,
    isAssessorManagementEnabled: PropTypes.bool
  }

  static defaultProps = {
    formPrefix: 'assessor',
    sectionIntlKey: 'formTitle.assessor_details',
    sectionTitle: 'Assessor Details',
    promptIntlKey: 'label.select_award_unit_assessor',
    promptDefault: 'Select from assessors already approved by your Award Unit or create a new one below',
    disabledIntlKey: 'label.assessor_disabled_for_other_activity',
    disabledDefault: 'Assessor selection is disabled for other activity.',
    titles: []
  }

  capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  render() {
    const {
      colorClass,
      titles,
      formPrefix,
      sectionIntlKey,
      sectionTitle,
      promptIntlKey,
      promptDefault,
      disabledIntlKey,
      disabledDefault,
      subcategoryValue,
      setupAssessorId,
      assessor,
      disabled,
      isAssessorManagementEnabled
    } = this.props

    const isOthersSubCategory = subcategoryValue === 'others'

    const isAssessor = formPrefix === 'assessor'

    const dropdownAssessors = assessorsDropdownSelector(assessor, isOthersSubCategory, this.props)

    const isNoneOfTheseAssessor = setupAssessorId === 0

    return (
      <div>
        <Title h5 colorClass={colorClass}>
          <FormattedMessage id={sectionIntlKey} defaultMessage={sectionTitle} />
        </Title>

        {isAssessorManagementEnabled && isAssessor && <div>
          {!isOthersSubCategory && <FormattedMessage
            id={promptIntlKey}
            defaultMessage={promptDefault}
          />}
          {isOthersSubCategory && <div className={styles.assessorIsDisabled}><FormattedMessage
            id={disabledIntlKey}
            defaultMessage={disabledDefault}
          /></div>}
          {!isOthersSubCategory && <div className="row">
            <div className="col-xs-12">
              <Select
                name={`setup${this.capitalizeFirstLetter(formPrefix)}Id`}
                label=""
                intlKey=""
                options={dropdownAssessors}
                disabled={!subcategoryValue || isOthersSubCategory || disabled}
              />
            </div>
          </div>}
        </div>}

        {(!isAssessorManagementEnabled || isNoneOfTheseAssessor || !isAssessor) && !isOthersSubCategory && <div>
        <div className="row">
          <div className="col-xs-12">
            <Select
              name={`${formPrefix}Title`}
              label="Title"
              intlKey="label.title"
              options={titles}
              disabled={disabled}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Input name={`${formPrefix}Name`} label="Name" intlKey="label.name" maxLength={100}          disabled={disabled}/>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Input
              name={`${formPrefix}Email`}
              label="Email"
              type="email"
              intlKey="label.email"
              disabled={disabled}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Input
              name={`${formPrefix}Phone`}
              label="Phone"
              intlKey="label.phone"
              disabled={disabled}
            />
          </div>
        </div>

          {isNoneOfTheseAssessor && <div className="row">
            <div className="col-xs-12">
              <Input
                name={`${formPrefix}RelevantExperience`}
                label="Relevant Experience"
                intlKey="label.relevant_experience"
                disabled={disabled}
              />
            </div>
          </div>}
        </div>}
      </div>
    )
  }
}
export default Assessor
